<footer class="border-t border-cp-line">
  <div class="mx-auto max-w-[1200px] px-5 pb-10 pt-16 sm:px-8">
    <div class="grid grid-cols-2 gap-10 md:grid-cols-12">
      <div class="col-span-2 md:col-span-5">
        <a routerLink="/" class="flex w-fit items-center gap-2 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-cp-accent">
          <img src="assets/img/creditpathlogo.webp" alt="CreditPath Logo" width="24" height="24" class="h-6 w-6" />
          <span class="text-[16px] font-[560] lowercase tracking-[-0.02em] text-cp-ink">creditpath.io</span>
        </a>
        <p class="mt-5 max-w-xs text-[13px] leading-relaxed text-cp-muted">
          Equipping financial advisors to lead credit conversations, preserve capital, and protect client strategies.
        </p>
        <div class="mt-6 flex gap-1">
          <a href="https://www.linkedin.com/company/creditpath-io" target="_blank" rel="noopener noreferrer" aria-label="creditpath.io on LinkedIn" [class]="socialLink">
            <ng-icon name="phosphorLinkedinLogo" size="17" aria-hidden="true" />
          </a>
          <a href="https://www.instagram.com/creditpath.io" target="_blank" rel="noopener noreferrer" aria-label="creditpath.io on Instagram" [class]="socialLink">
            <ng-icon name="phosphorInstagramLogo" size="17" aria-hidden="true" />
          </a>
          <a href="https://x.com/creditpathio" target="_blank" rel="noopener noreferrer" aria-label="creditpath.io on X" [class]="socialLink">
            <ng-icon name="phosphorXLogo" size="17" aria-hidden="true" />
          </a>
        </div>
      </div>

      <nav aria-label="Product" class="md:col-span-2 md:col-start-7">
        <p class="text-[13px] font-[510] text-cp-ink">Product</p>
        <ul class="mt-4 space-y-2.5 text-[13px]">
          <li><button type="button" (click)="scrollToSection('solutions')" [class]="footerLink">Credit Solutions</button></li>
          <li><button type="button" (click)="scrollToSection('pricing')" [class]="footerLink">Pricing</button></li>
          <li><a routerLink="/request-terms" [class]="footerLink">Request Terms</a></li>
        </ul>
      </nav>

      <nav aria-label="Company" class="md:col-span-2">
        <p class="text-[13px] font-[510] text-cp-ink">Company</p>
        <ul class="mt-4 space-y-2.5 text-[13px]">
          <li><a routerLink="/about" [class]="footerLink">About</a></li>
          <li><a routerLink="/contact" [class]="footerLink">Contact</a></li>
          <li><button type="button" (click)="scrollToSection('faq')" [class]="footerLink">FAQ</button></li>
        </ul>
      </nav>

      <nav aria-label="Legal" class="md:col-span-2">
        <p class="text-[13px] font-[510] text-cp-ink">Legal</p>
        <ul class="mt-4 space-y-2.5 text-[13px]">
          <li><a routerLink="/privacy-policy" [class]="footerLink">Privacy</a></li>
          <li><a routerLink="/terms-and-conditions" [class]="footerLink">Terms</a></li>
        </ul>
      </nav>
    </div>

    <!-- Legal copy is verbatim from footer-v2. Do not edit without approval. -->
    <div class="mt-14 space-y-4 border-t border-cp-line pt-8 text-xs leading-relaxed text-cp-subtle">
      <p class="text-[13px] leading-normal text-cp-muted">© {{ currentYear }} creditpath.io. All rights reserved.</p>
      <p class="max-w-[110ch] text-[12px] leading-relaxed">Disclaimer: All credit terms and conditions presented through creditpath.io are preliminary, subject to change, and not final until a complete application is submitted, reviewed, and approved by the credit provider’s underwriting team. creditpath.io operates on a best-effort basis to match advisors with tailored lending options based on the information provided at the time of request. Final terms may vary based on full financial review, creditworthiness, and other underwriting criteria.</p>
      <p class="max-w-[110ch] text-[12px] leading-relaxed">creditpath.io provides infrastructure that connects financial advisors with third-party credit providers. We do not originate or issue credit. All loan approvals, terms, and conditions are determined solely by the credit provider.</p>
      <p class="max-w-[110ch] text-[12px] leading-relaxed"><i>creditpath.io does not provide tax, legal, or investment advice. All users should consult with their own licensed tax, legal, and financial professionals before acting on any information or offers presented through the platform. By using creditpath.io, users acknowledge and agree that creditpath.io and its affiliates are not liable for any decisions made or outcomes resulting from platform use, and agree to hold creditpath.io harmless from any related claims or damages.</i></p>
    </div>
  </div>
</footer>
